import { HttpClient, HttpHeaders } from '@angular/common/http';
import { finalize, map } from "rxjs/operators";
import { ToastrService } from "ngx-toastr";
import { Configuracoes } from "../entities/configuracoes";
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { isPlatformBrowser } from '@angular/common';
import { Inject, PLATFORM_ID } from '@angular/core';
import { Router } from "@angular/router";
@Injectable({
  providedIn: 'root', // ou fornecido no AppModule
})
export class HttpService {
  public loading: Boolean = false;
  public toastLoadingId: number;
  public plataformId
  public http: HttpClient;
  public toastService: ToastrService;


  constructor(http: HttpClient, public router: Router, toastService: ToastrService, @Inject(PLATFORM_ID) platformId: Object) {
    this.http = http;
    this.toastService = toastService;
    this.plataformId = platformId
  }

  /*request(path, form:FormData, callback, callbackErro?, messageError?) {
        this.showLoading();

        const req = new HttpRequest('POST', Configuracoes.API + path, form, {
            reportProgress: true,
            responseType: 'text'
        });


        this.http.request(req)
                 .pipe(map( resp => resp))
                 .subscribe(resp => this.callbackSuccess(resp, callback),
                            erro => this.callbackErro(erro, callbackErro, messageError));
    }*/

  postFile(path, form, callback, callbackErro?, messageError?) {
    this.showLoading();
    this.http
      .post(Configuracoes.API + path, form, this.getHttpOptionsEmpty())
      .pipe(map((resp) => resp))
      .subscribe(
        (resp) => this.callbackSuccess(resp, callback),
        (erro) => this.callbackErro(erro, callbackErro, messageError)
      );
  }

  post(path, form, callback, callbackErro?, messageError?) {
    this.showLoading();
    this.http
      .post(Configuracoes.API + path, form, this.getHttpOptions())
      .pipe(map((resp) => resp))
      .subscribe(
        (resp) => this.callbackSuccess(resp, callback),
        (erro) => this.callbackErro(erro, callbackErro, messageError)
      );
  }

  postPdf(path, form, callback, callbackErro?, messageError?) {
    this.showLoading();
    this.http
      .post(Configuracoes.PDF + path, form, this.getHttpOptions())
      .pipe(map((resp) => resp))
      .subscribe(
        (resp) => this.callbackSuccess(resp, callback),
        (erro) => this.callbackErro(erro, callbackErro, messageError)
      );
  }
  
  
  postXml(path, form, callback, callbackErro?, messageError?) {
    this.showLoading();
    this.http
      .post(Configuracoes.PDF + path, form, this.getHttpOptionsEmptyXML())
      .pipe(map((resp) => resp))
      .subscribe(
        (resp) => this.callbackSuccess(resp, callback),
        (erro) => this.callbackErro(erro, callbackErro, messageError)
      );
  }


  postLogin(path, form, callback, callbackErro?, messageError?) {
    this.showLoading();
    this.http
      .post(Configuracoes.API + path, form, this.getHttpOptions())
      .pipe(map((resp) => resp))
      .subscribe(
        (resp) => this.callbackSuccess(resp, callback),
        (erro) => this.callbackErro(erro, callbackErro, messageError)
      );
  }

  post2(path, form, callback, callbackErro?, messageError?) {
    this.showLoading();
    this.http
      .post(Configuracoes.API + path, form, this.getHttpOptions())
      .pipe(map((resp) => resp))
      .subscribe(
        (resp) => this.callbackSuccess(resp, callback),
        () => callbackErro()
      );
  }

  async get(path: string, callback: Function, callbackErro?: Function, messageError?: string): Promise<any> {
    this.showLoading();

    try {
      const resp = await firstValueFrom(
        this.http.get(Configuracoes.API + path, this.getHttpOptions())
      );
      this.callbackSuccess(resp, callback);
    } catch (erro) {
      this.callbackErro(erro, callbackErro, messageError);
    }
  }

  get2(path, callback, callbackErro?, messageError?) {
    var header = new HttpHeaders({
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      "response-type": "blob",
    });
    let req = { headers: header }
    this.showLoading();
    this.http
      .get(path, req)
      .pipe(map((resp) => resp))
      .subscribe(
        (resp) => this.callbackSuccess(resp, callback),
        (erro) => this.callbackErro(erro, callbackErro, messageError)
      );
  }

  getPromisse(path) {
    this.showLoading();
    return this.http
      .get(Configuracoes.API + path, this.getHttpOptions())
      .pipe(map((resp) => resp))
      .pipe(finalize(() => this.dimissLoading()))
      .toPromise();
  }

  delete(path, callback, callbackErro?, messageError?) {
    this.showLoading();
    this.http
      .delete(Configuracoes.API + path, this.getHttpOptions())
      .pipe(map((resp) => resp))
      .subscribe(
        (resp) => this.callbackSuccess(resp, callback),
        (erro) => this.callbackErro(erro, callbackErro, messageError)
      );
  }

  put(path, form, callback, callbackErro?, messageError?) {
    this.showLoading();
    this.http
      .put(Configuracoes.API + path, form, this.getHttpOptions())
      .subscribe(
        (resp) => this.callbackSuccess(resp, callback),
        (erro) => this.callbackErro(erro, callbackErro, messageError)
      );
  }

  callbackSuccess(resp, callback) {
    this.dimissLoading();
    callback(resp);
  }

  callbackErro(error, callback?, message?) {
    this.dimissLoading();
    if (callback || callback !== undefined) {
      callback(error);
      return;
    }
    let msg = "Ocorreu um problema. " + "Erro: " + JSON.stringify(error);
    if (message) msg = message;

    if (error.status == 403) {
      //403 Forbidden
      msg = $localize`Usuário não autenticado`;
      this.toastService.info(msg, "", {
        timeOut: 4000,
      });
      this.router.navigate(['/login']).then(() => {
        window.location.reload();
      });
    }
    if (error.status !== undefined) {
      this.toastService.info(msg, "", {
        timeOut: 4000,
      });
    }
  }

  getHttpOptions() {
    let headersObj: any = {
      'Content-Type': 'application/json',
      Branch: Configuracoes.API_BRANCH,
      'Access-Control-Allow-Origin': '*'
    };

    if (this.hasToken()) {
      headersObj = {
        ...headersObj,
        Authorization: 'Bearer ' + this.getToken()
      };
    }

    const headers = new HttpHeaders(headersObj);
    return { headers };
  }

  getHttpOptionsEmptyXML() {
    let headersObj: any = {
      Branch: Configuracoes.API_BRANCH,
      'Access-Control-Allow-Origin': '*',
      "Content-Type": "application/xml",
      "Accept": "application/xml",
    };

    if (this.hasToken()) {
      headersObj = {
        ...headersObj,
        Authorization: 'Bearer ' + this.getToken()
      };
    }

    const headers = new HttpHeaders(headersObj);
    return { headers };
  }

  getHttpOptionsEmpty() {
    let headersObj: any = {
      Branch: Configuracoes.API_BRANCH,
      'Access-Control-Allow-Origin': '*'
    };

    if (this.hasToken()) {
      headersObj = {
        ...headersObj,
        Authorization: 'Bearer ' + this.getToken()
      };
    }

    const headers = new HttpHeaders(headersObj);
    return { headers };
  }

  showLoading() {
    this.loading = true;
    this.toastLoadingId = this.toastService.show(
      '<div class="spinner-grow text-primary" role="status"><span class="sr-only">Loading...</span></div>',
      "",
      {
        enableHtml: true,
      }
    ).toastId;
  }

  dimissLoading() {
    this.loading = false;
    this.toastService.clear(this.toastLoadingId);
  }

  /*isLogged() {
        return this.getToken() != null;
    }*/

  getToken() {
    if (isPlatformBrowser(this.plataformId)) {
      return window.localStorage.getItem("token");
    }
  }

  hasToken() {
    if (isPlatformBrowser(this.plataformId)) {
      return window.localStorage.getItem("token") != null;
    }
  }
}
